import HelpInquireContainer from './HelpInquireContainer';
export default HelpInquireContainer;
